const WorkspaceIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Workspaces">
        <g id="colors-square">
          <g id="Group">
            <path
              id="Vector"
              d="M13.2 14.7639C13.2 15.8239 12.74 16.7839 12 17.4439C11.36 18.0239 10.52 18.3639 9.59998 18.3639C7.60998 18.3639 6 16.7539 6 14.7639C6 13.1039 7.13002 11.7039 8.65002 11.2939C9.06002 12.3339 9.94999 13.1439 11.05 13.4439C11.35 13.5239 11.67 13.5739 12 13.5739C12.33 13.5739 12.65 13.5339 12.95 13.4439C13.11 13.8439 13.2 14.2939 13.2 14.7639Z"
               stroke="#0D0D0D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Vector_2"
              d="M15.6003 9.96426C15.6003 10.4343 15.5103 10.8843 15.3503 11.2943C14.9403 12.3343 14.0504 13.1443 12.9504 13.4443C12.6504 13.5243 12.3304 13.5743 12.0004 13.5743C11.6704 13.5743 11.3504 13.5343 11.0504 13.4443C9.95035 13.1443 9.06039 12.3443 8.65039 11.2943C8.49039 10.8843 8.40039 10.4343 8.40039 9.96426C8.40039 7.97426 10.0104 6.36426 12.0004 6.36426C13.9904 6.36426 15.6003 7.97426 15.6003 9.96426Z"
               stroke="#0D0D0D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Vector_3"
              d="M18 14.7642C18 16.7542 16.39 18.3642 14.4 18.3642C13.48 18.3642 12.64 18.0142 12 17.4442C12.74 16.7942 13.2 15.8342 13.2 14.7642C13.2 14.2942 13.11 13.8442 12.95 13.4342C14.05 13.1342 14.94 12.3342 15.35 11.2842C16.87 11.7042 18 13.1042 18 14.7642Z"
               stroke="#0D0D0D"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            id="Vector_4"
            d="M9 22.3643H15C20 22.3643 22 20.3643 22 15.3643V9.36426C22 4.36426 20 2.36426 15 2.36426H9C4 2.36426 2 4.36426 2 9.36426V15.3643C2 20.3643 4 22.3643 9 22.3643Z"
             stroke="#0D0D0D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export default WorkspaceIcon;
